import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute — garde l'accès à une route.
 *
 * Props :
 * - roles : array de rôles autorisés. Si vide ou non fourni, n'importe quel
 *           user connecté peut accéder. Sinon, le rôle de l'user doit être
 *           dans la liste.
 *
 * Comportement :
 * - Pas connecté → redirection vers /login
 * - Connecté mais rôle non autorisé → redirection vers /dashboard
 * - Connecté avec le bon rôle → on rend les enfants
 */
export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-page">
        <div className="loading-logo">Lexback</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si des rôles sont spécifiés, l'user doit en avoir un
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
